export const getMappedMonthKey = (priceKey: string) => {
  switch (priceKey) {
    case 'price1m':
      return 1
    case 'price12m':
      return 12
    case 'price24m':
      return 24
    case 'price36m':
      return 36
    default:
      return 0
  }
}

export const getResalePriceKeyCamelizeConversion = (key: string): string => {
  switch (key) {
    case 'price_1m':
      return 'price1m'
    case 'price_12m':
      return 'price12m'
    case 'price_24m':
      return 'price24m'
    case 'price_36m':
      return 'price36m'
    case 'additional_usage_price':
      return 'additionalUsagePrice'
    case 'subscription_price':
      return 'subscriptionPrice'
    default:
      return key
  }
}
